import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ProveedorInvitadoCz } from '../../models/proveedor_invitado_cz';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';
import { InvitacionCz } from '../../models/invitacion_cz';
import { AdjudicadaCz } from '../../models/adjudicada_cz';
import { CantidadCz } from '../../models/cantidad_cz';
import { ProveedorMonthlyCz } from '../../models/proveedor_monthly_cz';
import { AdjudicadaMonthlyCz } from '../../models/adjudicada_monthly_cz';
import { OrigenOcCz } from '../../models/origen_oc_cz';
import { MontoOrigenOcCz } from '../../models/monto_origen_oc_cz';
import { PromedioAperturaCz } from '../../models/promedio_apertura_cz';
import { PorcentajeEstadoCz } from '../../models/porcentaje_estado_cz';
import { ICCookieService } from '../cookie/iccookie.service';

@Injectable({
  providedIn: 'root',
})
export class CotizacionService {
  idEmpresa: string = '0';

  constructor(
    private http: HttpClient,
    private _ICCookieService: ICCookieService
  ) {
    this.idEmpresa = this._ICCookieService.getCookie('IDEMPRESA') || '0';
  }

  getInvitaciones(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<InvitacionCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_invitaciones`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getProveedoresInvitados(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<ProveedorInvitadoCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_proveedores_invitados`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getOfertas(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<CantidadCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/of_cantidad`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getCotizacionesAdjudicadas(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<AdjudicadaCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_adjudicadas`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getCotizacionesMonthtly(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<AdjudicadaMonthlyCz[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_adjudicadas_monthly`,
      { params }
    );
  }

  getInvitadosMonthtly(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http.get<ProveedorMonthlyCz[]>(
      `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_proveedores_monthly`,
      { params }
    );
  }

  getOrigenCotizaciones(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<OrigenOcCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_origen_oc`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getMontosOrigenCotizaciones(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<MontoOrigenOcCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_montos_origen_oc`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getPlazoPromedioApertura(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<PromedioAperturaCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_promedio_apertura`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }

  getPocentajeEstado(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get<PorcentajeEstadoCz[]>(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz_porcentaje_estado`,
        { params }
      )
      .pipe(map((res) => res[0]));
  }
  getReporteCz(
    fechaInicio: number,
    fechaFin: number,
    idCentroGestion: number,
    idProveedor: number
  ) {
    let params: any = {
      id_fecha_inicio: fechaInicio,
      id_fecha_fin: fechaFin,
    };

    if (idCentroGestion > 0) {
      params.id_centro_gestion = idCentroGestion;
    }

    if (idProveedor > 0) {
      params.id_proveedor = idProveedor;
    }

    return this.http
      .get(
        `${environment.apiBaseUrl}/empresas/${this.idEmpresa}/cz-reporte`,
        { params, responseType: 'blob' }
      );
  }
}
